<template>
    <b-modal
            id="remove-user-modal"
            :title="title"
            v-model="showModal"
            centered no-close-on-backdrop
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel">
        <b-overlay :show="isLoading" rounded="sm">
            <b-alert v-if="isLoadingError" variant="danger" class="m-5" show>
                <p>There was a problem loading this item,</p>
                <p>Please try again.</p>
            </b-alert>

            <b-card v-else bg-variant="danger" text-variant="white" >
                <b-card-text>
                    <span>Warning - Removing a user from the organization will disable access to all athlete and session data for the user.</span>
                    <br/>
                    <span>No athlete or session data will be deleted, but you will have to invite the user again to restore their access.</span>
                </b-card-text>
            </b-card>

          <form ref="form" v-on:submit.prevent="noop">
            <b-form-group class="mt-2">
              <b-form-checkbox
                  id="notify-checkbox"
                  v-model="notifyValue"
                  name="notify-checkbox"
                  value="true"
                  unchecked-value="false"
              >
                Send Email Notification To User
              </b-form-checkbox>
            </b-form-group>
          </form>

        </b-overlay>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="danger" @click="ok()">
                Delete
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="cancel()">
                Cancel
            </b-button>
        </template>

        <b-modal id="error-modal" size="sm" title="Action failed" ok-only centered>
            <p class="m-2">There was a problem completing the action, Please try again.</p>
        </b-modal>

    </b-modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        name: "OrganizationRemoveUserModal",
        data() {
            return {

                showModal: false,

                title: "Remove User From Organization",

                notifyValue: false,

                showValidation: false,

            }
        },
        computed: {
            ...mapGetters({
                model: 'organizationUserAccount/current',
                isModelLoading: 'organizationUserAccount/currentLoading',
                isModelLoadingError: 'organizationUserAccount/currentLoadingError',
            }),

            isLoading: function() {
                return this.isModelLoading;
            },
            isLoadingError: function() {
                return this.isModelLoadingError;
            },


        },
        methods: {
            ...mapActions({
                removeUser: 'organizationUserAccount/removeUser',
            }),
            resetModel() {
                this.showValidation = false;
                this.title =  "Remove";
            },
            handleOk(bvModalEvt) {

                // Prevent modal from closing
                bvModalEvt.preventDefault()

                if (this.isLoading) {
                    return
                }

                let self = this;

                self.removeUser({ organizationId: self.model.organizationId, userId: self.model.userAccountId, notify: self.notifyValue })
                    .then(function(success) {
                        if(success) {
                            self.resetModel(null);
                            self.closeModal();
                        } else {
                            self.$bvModal.show('error-modal')
                        }

                    });

            },
            handleCancel(bvModalEvt) {
                // Prevent modal from closing
                bvModalEvt.preventDefault()

                if (this.isLoading) {
                    return
                }

                this.closeModal()
            },
            closeModal() {
                this.$nextTick(() => {
                    this.$bvModal.hide('remove-user-modal')
                })
            }
        }
    }
</script>

<style scoped>

</style>